const WinlosesTypes = {
    FETCH_START:    '[STATISTICS] FETCH START',
    FETCH_SUCCESS:  '[STATISTICS] FETCH SUCCESS',
    FETCH_FAILURE:  '[STATISTICS] FETCH FAILURE'
};

export default WinlosesTypes;